import { createReducer, AnyAction } from '@reduxjs/toolkit';
import { AppNotification, AppNotificationInterface } from '../../models/AppNotification';
import { ActionType } from './actions';

export interface AppState {
	list: AppNotificationInterface[];
}

const initialState: AppState = {
  list: [],
};

const pushNotification = (state: AppState, action: AnyAction) => {
  const notification = action.payload as AppNotificationInterface;
  return { ...state, list: [...state.list, notification] };
};

const shiftNotification = (state: AppState) => {
  const copyList = [...state.list];
  copyList.shift();
  return { ...state, list: copyList };
};

const removeNotification = (state: AppState, action: AnyAction) => {
  const deleteNotification = action.payload as AppNotificationInterface;
  const copyList: AppNotificationInterface[] = [];
  state.list.forEach(stateNotification => {
    if (!AppNotification.match(deleteNotification, stateNotification)) {
      copyList.push(stateNotification);
    }
  });
  return { ...state, list: copyList };
};

const removeNotifications = (state: AppState, action: AnyAction) => {
  const deleteNotifications = action.payload as AppNotificationInterface[];
  const copyList: AppNotificationInterface[] = [];
  state.list.forEach(stateNotification => {
    let inDeleteList = false;
    for (const deleteNotification of deleteNotifications) {
      if (AppNotification.match(deleteNotification, stateNotification)) {
        inDeleteList = true;
        break;
      }
    }
    if (!inDeleteList) {
      copyList.push(stateNotification);
    }
  });
  return { ...state, list: copyList };
};

const notificationReducer = createReducer(initialState, {
  [ActionType.PUSH]: pushNotification,
  [ActionType.SHIFT]: shiftNotification,
  [ActionType.REMOVE]: removeNotification,
  [ActionType.REMOVE_LIST]: removeNotifications,
  [ActionType.RESET]: () => ({ ...initialState }),
});

export default notificationReducer;
